import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Observable } from 'rxjs';
import { RoutesEnum } from 'src/app/constants/RoutesEnum';
import { ICombo } from 'src/app/usuarios/models/combo.model';
import { navLinks } from './nav-links';

@Injectable({
  providedIn: 'root'
})
export class NavLinksService {

  #navLink = new BehaviorSubject<MenuItem[]>(navLinks)
  roles: ICombo[] = [];
  get navLinks(): Observable<MenuItem[]> {
    return this.#navLink.asObservable()
  }


  setNavLinks(navLinks: MenuItem[]): void {
    this.#navLink.next(navLinks)
  }

  filterNavLinksByRole(roles: String[]): void {
      const roleNames = roles
      let filteredNavLinks: MenuItem[];
       if (roleNames.includes('Admin')) {
        // Si es Admin ve todos los links
        filteredNavLinks = navLinks
      } 
      else if (roleNames.includes('AdminEmpresa'))  {
        // Si es AdminEmpresa o VIsor no ve Mantenimiento
        filteredNavLinks = navLinks.filter(link => link.label !== 'Mantenimientos');
      }  else if (roleNames.includes('Soporte')) {
        // Si es Soporte, muestra solo Mantenimientos
        filteredNavLinks = navLinks.map(link => {
          if (link.label === 'Opciones') {
            return {
              ...link,
              items: [
                {
                  label: 'Configuración de Mantenimientos',
                  routerLink: RoutesEnum.MantenimientoReportComponent,
                }
              ]
            };
          }
          return link;
        }).filter(link => link.label === 'Mantenimientos' || link.label === 'Opciones');
      }
      else if (roleNames.includes('Visor'))  {
        // Si es Visor o no ve opciones
        filteredNavLinks = navLinks.filter(link => link.label !== 'Opciones' && link.label !== 'Mantenimientos');
      } 
       else {
        filteredNavLinks = []; // Predeterminado
      }
      this.setNavLinks(filteredNavLinks);
  }

}
